import styled from 'styled-components'

export const Container = styled.div`
    margin:  1rem;
    max-width: 900px;

   
`
export const DisplayColorBox = styled.div`
    padding: 14px;
    margin-right: 8px;
    border-radius: 5px;
    border: 1px solid gray;
`